import { render, staticRenderFns } from "./DisplayThemes.vue?vue&type=template&id=3a0cebd2"
import script from "./DisplayThemes.vue?vue&type=script&lang=ts"
export * from "./DisplayThemes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports